<div class="payroll-form">
  <div *ngIf="loading" class="padding text-center">
    <i class="fa fa-spinner fa-spin"></i>
  </div>
  <div *ngIf="payroll">
    <div *ngIf="hasErrors()" class="alert alert-danger error-bar m-x-sm">
        <span class="text-danger  d-flex align-items-center">
          <i class="fa fa-exclamation-circle fa-2x"></i>
        </span>

      <div class="error-text text-dark" id="error-panel-desc">
        <strong>{{ 'SDC.error.title' | translate }}</strong>
        <div>
          {{ 'SDC.error.description' | translate }}
          <ng-container *ngFor="let variableType of failedPayrollVariableTypes(); let isLast = last">
            <a class="text-danger" (click)="scrollTo(variableType)">{{ variableType }}</a>{{ isLast ? '.' : ', ' }}
          </ng-container>
        </div>
      </div>

      <button class="btn btn-danger d-flex align-items-center gap-2" (click)="openErrorPanel()">
        <i class="fa fa-exclamation-triangle m-x-sm"> </i>
        <span>{{ 'SDC.error.view' | translate }}</span>
      </button>
    </div>

    <gp-side-panel
      [isSidePanelOpen]="errorPanelOpened"
      (isSidePanelOpenChange)="onChange($event)"
      [sidePanelTitle]="'SDC.error.details' | translate">
      <div class="box-body m-t-sm">
        <ng-container *ngIf="failedSdcLogs() as failedLogs">
          <gp-sdc-person-feedback
            *ngFor="let sdcLog of failedLogs"
            [sdcLog]="sdcLog">
          </gp-sdc-person-feedback>
        </ng-container>
      </div>
    </gp-side-panel>

    <gp-pay-period-selector-bar
      class="d-block m-x-sm"
      [contractId]="contractId"
      [contractBeginDate]="contractBeginDate"
      [contractEndDate]="contractEndDate"
      (payPeriodChange)="onPayPeriodChange($event)">
    </gp-pay-period-selector-bar>

    <ng-container *ngFor="let payrollVariableType of payrollVariableTypes">
      <div class="payroll-variable m-x-sm" [attr.id]="payrollVariableType + '-variableBlock'">
        <div class="card-container">
          <div class="card-header">
            <h3 class="payroll-variable-title">{{ metadata(payrollVariableType)?.name }}</h3>
          </div>

          <gp-table *ngIf="data(payrollVariableType)?.length; else noData" class="table payroll-table">
            <thead gp-table-head>
            <tr role="row">
              <th class="column-title text-muted small" gp-table-column scope="col">
                {{ 'COMMON.status' | translate }}
              </th>
              <th *ngIf="dated(payrollVariableType)" class="column-title text-muted small" gp-table-column scope="col">
                {{ 'SDC.period' | translate }}
              </th>
              <th *ngFor="let field of fields(payrollVariableType)"
                  class="column-title text-muted small" gp-table-column scope="col">
                {{ field }}
              </th>
              <th *ngFor="let field of additionalFields(payrollVariableType)"
                  class="column-title text-muted small" gp-table-column scope="col">
                {{ field }}
              </th>
              <th *ngIf="payrollVariableType === 'OneOffPayrollInputData'"
                  class="column-title payroll-empty-column"
                  aria-hidden="true"
                  scope="col"
                  gp-table-column>
                &nbsp;
              </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let datum of data(payrollVariableType)" [class.is-deleted]="datum.isDeletion">
              <td>
                <span class="payroll-status" [ngClass]="'payroll-status-' + datum.status">
                  {{ ('SDC.' + datum.status) | translate }}
                </span>
              </td>
              <td *ngIf="dated(payrollVariableType)" class="text-nowrap">
                <ng-container *ngIf="datum.values?.['startDate'] && datum.values?.['endDate']">
                  {{ datum.values['startDate'] | dateInfinity }} → {{ datum.values['endDate'] | dateInfinity }}
                </ng-container>
              </td>
              <td *ngFor="let field of fields(payrollVariableType)">
                {{ datum.values?.[field] || '-' }}
              </td>
              <td *ngFor="let field of additionalFields(payrollVariableType)">
                {{ datum.values?.[field] || '-' }}
              </td>
              <td *ngIf="payrollVariableType === 'OneOffPayrollInputData'"
                  class="payroll-empty-column"
                  aria-hidden="true">
                &nbsp;
              </td>
            </tr>
            </tbody>
          </gp-table>
          <ng-template #noData>
            <div class="padding text-center">
              {{ 'COMMON.no_table_data' | translate }}
            </div>
          </ng-template>
        </div>
      </div>
    </ng-container>
  </div>
</div>
